import { render, staticRenderFns } from "./answer-list.vue?vue&type=template&id=693e6f7c&scoped=true"
import script from "./answer-list.vue?vue&type=script&lang=js"
export * from "./answer-list.vue?vue&type=script&lang=js"
import style0 from "./answer-list.vue?vue&type=style&index=0&id=693e6f7c&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "693e6f7c",
  null
  
)

export default component.exports